<template>
  <div class="comments">
    <div v-for="item in dataList" :key="item.id">
      <div class="comment-wrap">
        <div class="photo">
          <!-- ~@/assets/beijing.png -->
          <div
            class="avatar justUser"

          ></div>
          <!--   background-image: url("../assets/images/ture_bg.png"); -->
          <!-- http://gangmao.oss-cn-shenzhen.aliyuncs.com/qiaoxishan/user.png -->
        </div>
        <div class="comment-block">
          <p class="comment-text">
            {{ item.content }}
          </p>
          <div class="bottom-comment">
            <div class="comment-date">{{ item.createDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="comment-wrap">
      <div class="photo">
        <div
          class="avatar justUser"
        ></div>
      </div>
      <div class="comment-block">
        <form action="">
          <textarea
            name=""
            id=""
            cols="30"
            rows="3"
            placeholder="发表你的评论。。。。。。。。。。"
            v-model="info.content"
          ></textarea>
        </form>
        <a-button
          type="primary"
          style="float:right;margin-top:50px"
          @click="btnClick"
          >评论</a-button
        >
      </div>
    </div> -->

    <a-modal
      v-model="visible"
      title="填写信息"
      :footer="null"
      cancelText="取消"
      okText="提交"
    >
      <a-form-model
        ref="ruleForm"
        :model="info"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="姓名" prop="name">
          <a-input v-model="info.name" />
        </a-form-model-item>

        <a-form-model-item ref="mobile" label="手机号" prop="mobile">
          <a-input v-model="info.mobile" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 8 }">
          <a-button type="primary" @click="onSubmit">
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click="resetForm">
            取消
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getOtherComment, addOtherComment } from '@/api/public'
export default {
  data () {
    return {
      dataList: [],
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      other: '',
      info: { flag: 1, content: ''},
      rules: {
        name: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    onSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          addOtherComment(this.info).then(response => {
            if (response.code == 200) {
              this.$message.success('提交成功!')
              this.info.content = ''
              this.visible = false
            } else {
              this.$message.error('提交失败!')
              this.visible = false
            }
          })
        } else {
          return false
        }
      })
    },
    btnClick () {
      this.info.content.length == 0 ? this.$message.error('请填写评论内容!') : this.visible = true
    },
    resetForm () {
      this.visible = false
    },
    getInfoList () {
      getOtherComment(1).then(response => {
        this.dataList = response.data
      })
    }
  }
}
</script>

<style scoped>
.justUser {
   background-image: url('../assets/xqsimage/user.png')
}
html,
body {
  background-color: #f0f2fa;
  font-family: "PT Sans", "Helvetica Neue", "Helvetica", "Roboto", "Arial",
    sans-serif;
  color: #555f77;
  -webkit-font-smoothing: antialiased;
}

textarea {
  outline: none;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  font-family: "PT Sans", "Helvetica Neue", "Helvetica", "Roboto", "Arial",
    sans-serif;
  font-size: 1rem;
  color: #555f77;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #ced2db;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #ced2db;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #ced2db;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #ced2db;
}
p {
  line-height: 1.3125rem;
}
.comments {
  margin: 2.5rem auto 0;
  max-width: 1197px;
  padding: 0 1.25rem;
  text-align: left;
}
.comment-wrap {
  margin-bottom: 1.25rem;
  display: table;
  width: 100%;
  min-height: 5.3125rem;
}
.photo {
  padding-top: 0.625rem;
  display: table-cell;
  width: 3.5rem;
}
.photo .avatar {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 50%;
  background-size: contain;
}
.comment-block {
  padding: 1rem;
  background-color: #fff;
  display: table-cell;
  vertical-align: top;
  border-radius: 0.1875rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
}
.comment-block textarea {
  width: 100%;
  max-width: 100%;
}
.comment-text {
  margin-bottom: 1.25rem;
}
.bottom-comment {
  color: #acb4c2;
  font-size: 0.875rem;
}
.comment-date {
  float: left;
}
.comment-actions {
  float: right;
}
.comment-actions li {
  display: inline;
}
.comment-actions li.complain {
  padding-right: 0.625rem;
  border-right: 1px solid #e1e5eb;
}
.comment-actions li.reply {
  padding-left: 0.625rem;
}
</style>



// WEBPACK FOOTER //
// src/components/comment.vue